<script>
    import { format } from "svelte-i18n";
</script>
<style>

    .logo-img{
        margin-top: 4px !important;
        height: 48px !important;
        max-width: 176px !important;
    }

    .card.card-outline {
        margin: 0;
        height: 400px;
        font-size: 1.5em;
        flex: 1;
        align-self: center;
        max-width: 800px;
    }

    section {
        min-height: 100vh;
        display: flex !important;
        flex-direction: row;
        justify-content: center;
        padding: 0 !important;
        margin: 0 !important;
    }

</style>

<section class="col-12">
    <div class="card card-outline">
        <div class="card-header text-center">
            <img
                src="/img/logo-vulseek-red-with-legend.png"
                alt="Vulseek by Securetia"
                class="brand-image logo-img logo-img-login"
            />
        </div>
        <div class="card-body d-flex flex-column justify-content-center">
            <div class="text-center">
                <p><strong>{$format("page.register.request_recieved")}</strong></p>
                <p><strong>{$format("page.register.check_email")}</strong></p>
            </div>
        </div>
        <!-- /.card-body -->
    <!-- /.card -->
    </div>
    <!-- /.login-box -->
</section>
